module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/house-pound-f8ab3b0b5a82fe328bda7f6ff90b5eb2.svg";